<div appResizeObserver>
  <router-outlet />
</div>
